import React, { useEffect, useState, Fragment, Suspense, lazy } from 'react';
import { useT } from '../i18n';
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { ethers } from 'ethers';
import {
  nftNodes,
  nftNodesCFG,
  MultiCall,
  wsprovider,
  provider,
  bckpProvider,
  luckBlocksAddress,
  luckBlocksWAddress,
  ethLuckBlocksAddress,
  ethluckBlocksWAddress,
  maticLuckBlocksAddress,
  maticLuckBlocksWAddress,
  CRANNILuckBlocksAddress,
  CRANNILuckBlocksWAddress,
  cranniAddress
} from '../.config';
import { shortAddress, timeConverter } from '../utils';
import luckBlocksNodes from '../abi/luckBlocksNodes.json';
import luckBlocksNodesCFG from '../abi/luckBlocksNodesCFG.json';
import Multicall from '../abi/Multicall.json';
import erc20ABI from '../abi/ERC20_ABI.json';
import btc from '../assets/utility/bitcoin.png';
import eth from '../assets/utility/ethereum.png';
import matic from '../assets/utility/matic.png';
import CRANNI from '../assets/utility/CRANNI.png';
import lbDialog from '../components/UI/Modals/lbDialog';
import { writeContract } from '@wagmi/core';
import crannigif from '../assets/utility/crannigifs.gif';
import opensea from '../assets/utility/opensea.webp';
import rarible from '../assets/utility/rarible.webp';
import { useWriteContract } from 'wagmi';
import { useAppKitAccount } from "@reown/appkit/react";
import Spinner from '../components/UI/Spinner';
import Governance from '../components/Governance/Governance';
import NodesFlow from '../components/NodesFlow/NodesFlow';
import NodeTasks from '../components/NodeTasks/NodeTasks';

const NFTLogs = lazy(() => import('../NFTLogs'));
const CarouselInWallet = lazy(() => import('../CarouselINWallet'));
const CarouselInStaked = lazy(() => import('../CarouselINStaked'));

const NFTnodes = () => {
  const t = useT();
  const [loading, setLoading] = useState(true);
  const [pageChange, setPageChange] = useState(true);
  const [isApproved, setIsApproved] = useState(false);
  const [myStatusC, setStatusC] = useState(false);
  const [myStatusG, setStatusG] = useState(false);
  const [txs, setTxs] = useState([]);
  const [nftsInWallet, setNFTs] = useState([]);
  const [nftsStaked, setStakedNFTs] = useState([]);
  const [contractWatched, setContractWatched] = useState("Bitcoin");
  const [dailyContract, setDailyContract] = useState(luckBlocksAddress);
  const [weeklyContract, setWeeklyContract] = useState(luckBlocksWAddress);
  const [activeQueue, setAQ] = useState([]);
  const [waitingQueue, setWQ] = useState([]);
  const [activeQueueG, setAQG] = useState([]);
  const [waitingQueueG, setWQG] = useState([]);
  const [nextSpins, setNS] = useState([]);
  const [nextSpinsW, setNSW] = useState([]);
  const [salePhase, setPhase] = useState(0);
  const [price, setPrice] = useState(0); // POL (wei) per node, sent as the tx value
  const [cranniPrice, setCranniPrice] = useState(0); // CRANNI per node, approved to the contract
  const [pendingMints, setPendingMints] = useState([]); // this wallet's mints waiting for their reveal
  const [nextToReveal, setNextToReveal] = useState(0);
  const [revealing, setRevealing] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const [remainingOnPhase, setRemainingPhase] = useState(0);
  const [page, setPage] = useState(1);
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } = useAppKitAccount();
  const [isMobile, setIsMobile] = useState(false);
  const { writeContractAsync } = useWriteContract();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const openseaLink = 'https://opensea.io/collection/cranni-societas';
  const raribleLink = 'https://rarible.com';

  // contract phases 1-4: phase 1 has 10 slots, 4 of them taken by the pre-minted nodes, then 15, 15 and 10 (46 for sale,
  // golden and common nodes together in the random draw)
  const FIRST_PUBLIC_PHASE = 1;
  // a mint also reveals the oldest pending one, whose path depends on a block hash: a fresh gas estimate can fall short
  const MINT_GAS = 900000n;
  const REVEAL_GAS_PER_NODE = 400000; // a reveal uses up to ~330k
  const MAX_REVEALS = 10;
  const CRANNI_DECIMALS = 8;

  const phaseSupplyMap = {
    0: 6,
    1: 15,
    2: 15,
    3: 10,
  };

  const phaseTimeline = [
    {
      id: 0,
      title: 'nodes.phase0',
      dates: '',
      requirement: 'nodes.whitelistReq',
      price: '',
    },
    {
      id: 1,
      title: 'nodes.phase1',
      dates: '',
      requirement: 'nodes.publicMint',
      price: '',
    },
    {
      id: 2,
      title: 'nodes.phase2',
      dates: '',
      requirement: 'nodes.publicMint',
      price: '',
    },
    {
      id: 3,
      title: 'nodes.phase3',
      dates: '',
      requirement: 'nodes.publicMint',
      price: '',
    },
  ];

  const marketplaceLinks = [
    {
      name: 'OpenSea',
      href: openseaLink,
      logo: opensea,
      accent: 'from-sky-400 to-blue-600',
    },
    {
      name: 'Rarible',
      href: raribleLink,
      logo: rarible,
      accent: 'from-amber-300 to-orange-500',
    },
  ];

  const queueTheme = {
    gold: {
      title: t('nodes.golden'),
      gradient: 'from-amber-400/30 via-orange-500/20 to-pink-500/20',
      label: 'text-amber-200',
    },
    common: {
      title: t('nodes.common'),
      gradient: 'from-sky-400/20 via-blue-500/20 to-brand-light/20',
      label: 'text-sky-200',
    },
  };

  const salePhaseNumber = Math.max(Number(salePhase || 0) - FIRST_PUBLIC_PHASE, 0);
  const totalPhaseSupply =
    phaseSupplyMap[salePhaseNumber] ?? phaseSupplyMap[0];
  const remainingInPhase = Number(remainingOnPhase || 0);
  const mintedOnPhase = Math.max(totalPhaseSupply - remainingInPhase, 0);
  const mintedProgress = totalPhaseSupply
    ? Math.min((mintedOnPhase / totalPhaseSupply) * 100, 100)
    : 0;

  const formattedPrice = (() => {
    try {
      const pol = Number(ethers.utils.formatEther(price || 0)).toLocaleString('en-US', { maximumFractionDigits: 2 });
      const cranniAmount = Number(ethers.utils.formatUnits(cranniPrice || 0, CRANNI_DECIMALS)).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      });
      return `${pol} POL + ${cranniAmount} CRANNI`;
    } catch (error) {
      return 'POL + CRANNI';
    }
  })();

  let nftsArray = [];
  let nftsStakedArray = [];


  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const section = urlParams.get('section') || 'about';
    switch (section) {
      case 'about':
        setPage(1);
        break;
      case 'mintbuy':
      case 'buy':
        setPage(2);
        break;
      case 'dashboard':
        setPage(3);
        break;
      case 'governance':
        setPage(4);
        break;
      default:
        setPage(1);
    }
  }, [location.search]);



  // Handle browser back/forward navigation


  const resetNfts = () => {
    nftsArray = [];
    nftsStakedArray = [];
    setNFTs([]);
    setStakedNFTs([]);
    setStatusC(false);
    setStatusG(false);
    setLoading(true);
    setTimeout(() => getQueues(), 2000);
    setTimeout(() => getMyNFTs(), 4000);
  };


  const changeLotteryToBTC = () => {
    setContractWatched("Bitcoin");
    setDailyContract(luckBlocksAddress);
    setWeeklyContract(luckBlocksWAddress);
  };

  const changeLotteryToETH = () => {
    setContractWatched("Ethereum");
    setDailyContract(ethLuckBlocksAddress);
    setWeeklyContract(ethluckBlocksWAddress);
  };

  const changeLotteryToMATIC = () => {
    setContractWatched("POL");
    setDailyContract(maticLuckBlocksAddress);
    setWeeklyContract(maticLuckBlocksWAddress);
  };
  const changeLotteryToCRANNI = () => {
    setContractWatched("CRANNI");
    setDailyContract(CRANNILuckBlocksAddress);
    setWeeklyContract(CRANNILuckBlocksWAddress);
  };

  const contract = new ethers.Contract(nftNodes, luckBlocksNodes.abi, provider);
  const contractCFG = new ethers.Contract(
    nftNodesCFG,
    luckBlocksNodesCFG.abi,
    wsprovider
  );
  const contractCFGbckp = new ethers.Contract(
    nftNodesCFG,
    luckBlocksNodesCFG.abi,
    bckpProvider
  );
  const multicontract = new ethers.Contract(
    MultiCall,
    Multicall.abi,
    bckpProvider
  );

  const spinStyle = {
    backgroundColor: 'black',
    color: 'white',
    padding: '10px',
    borderRadius: '10px',
    weight: 500,
    family: 'Tektur',
    size: 10,
    marginBottom: isMobile ? '10px' : '0',
  };

  //

  // Mint Page
  async function checkForApproval() {
    if (isConnected) {
      const contractToken = new ethers.Contract(
        cranniAddress,
        erc20ABI.abi,
        provider
      );
      const approval = await contractToken.allowance(address, nftNodes);

      if (approval.gte(cranniPrice || 0)) {
        setIsApproved(true);
      } else {
        setIsApproved(false);
      }
    }
  }

  async function approveToSpendCRANNI() {
    // the CRANNI part of exactly one node at the current price
    const approvalAmount = ethers.BigNumber.from(cranniPrice || 0).toBigInt();

    const hash = await writeContractAsync({
      address: cranniAddress,
      abi: erc20ABI.abi,
      functionName: 'approve',
      args: [nftNodes, approvalAmount],
    });

    // Wait for the transaction to be confirmed
    const receipt = await waitForTransactionConfirmation(hash);

    // Check if the transaction was successful
    if (receipt.status === 1) {
      console.log('Transaction successful!');
      setIsApproved(true);
      lbDialog.fire({
        title: t('tx.success'),
        text: t('nodes.msgApproved'),
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      console.log('Transaction failed!');
      // Handle failed transaction
      lbDialog.fire({
        title: t('nodes.danger'),
        text: t('nodes.msgTxFailed'),
        icon: 'error',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  async function handleMint() {
    if (isConnected) {
      const cranniToken = new ethers.Contract(cranniAddress, erc20ABI.abi, provider);
      const [polBalance, cranniBalance] = await Promise.all([provider.getBalance(address), cranniToken.balanceOf(address)]);

      if (cranniBalance.lt(cranniPrice || 0)) {
        lbDialog.fire({
          title: t('tx.error'),
          text: t('nodes.msgNoCranni'),
          icon: 'error',
        });
        return;
      }

      if (polBalance.lt(price || 0)) {
        lbDialog.fire({
          title: t('tx.error'),
          text: t('nodes.msgNoPol'),
          icon: 'error',
        });
        return;
      }

      if (remainingOnPhase < 1) {
        lbDialog.fire({
          title: t('tx.error'),
          text: t('dialog.noNodesInPhase'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      if (remaining < 1) {
        lbDialog.fire({
          title: t('tx.error'),
          text: t('nodes.msgAllMinted'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      if (salePhase < 1) {
        lbDialog.fire({
          title: t('nodes.info'),
          text: t('nodes.msgWhitelist'),
          icon: 'info',
          showConfirmButton: false,
          timer: 5000,
        });
      }

      const hash = await writeContractAsync({
        address: nftNodes,
        abi: luckBlocksNodes.abi,
        functionName: 'mint',
        value: ethers.BigNumber.from(price || 0).toBigInt(),
        gas: MINT_GAS,
      });

      // Wait for the transaction to be confirmed
      const receipt = await waitForTransactionConfirmation(hash);

      // Check if the transaction was successful
      if (receipt.status === 1) {
        console.log('Transaction successful!');
        // Perform additional actions or show success message
        lbDialog.fire({
          title: t('tx.success'),
          text: t('nodes.msgCommitted'),
          icon: 'success',
          showConfirmButton: false,
          timer: 3000,
        });
        getMintData();
        document.getElementById('bodyscroll').style.overflow = 'scroll';
      } else {
        console.log('Transaction failed!');
        // Handle failed transaction
        lbDialog.fire({
          title: t('nodes.danger'),
          text: t('nodes.msgTxFailed'),
          icon: 'error',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } else {
      console.log('please connect to wallet');
      lbDialog.fire({
        title: t('nodes.info'),
        text: t('nodes.msgConnect'),
        icon: 'info',
        showConfirmButton: true,
      });
    }
  }

  const waitForTransactionConfirmation = async (hash) => {
    const transactionReceipt = await provider.waitForTransaction(hash);
    return transactionReceipt;
  };

  async function getMintData() {
    const getphase = await contract.currentPhase();
    // whitelist or public price, whichever phase is running: POL + CRANNI
    const [currentPrice, currentCranniPrice] = await contract.mintPrice();
    const remainingPhase = await contract.remainingonphase();
    const totalSupply = await contract.totalSupply();

    const totalRemaining = 50 - totalSupply;

    //	currentPrice = ethers.utils.formatUnits(currentPrice.toString(),"ether");

    //		console.log(currentPrice);

    setRemaining(totalRemaining.toString());
    setRemainingPhase(remainingPhase.toString());
    setPhase(getphase.toString());
    setPrice(currentPrice);
    setCranniPrice(currentCranniPrice);

    if (address) {
      const [pending, next] = await Promise.all([contract.pendingOf(address), contract.nextToReveal()]);
      setPendingMints(pending.map((id) => id.toNumber()));
      setNextToReveal(next.toNumber());
    } else {
      setPendingMints([]);
    }
  }

  // Reveals this wallet's pending mints (and any older ones ahead of them, oldest first)
  async function handleReveal() {
    if (!pendingMints.length || revealing) return;
    const count = Math.min(pendingMints[pendingMints.length - 1] - nextToReveal + 1, MAX_REVEALS);
    setRevealing(true);
    try {
      const hash = await writeContractAsync({
        address: nftNodes,
        abi: luckBlocksNodes.abi,
        functionName: 'revealPending',
        args: [ethers.BigNumber.from(count).toBigInt()],
        gas: ethers.BigNumber.from(REVEAL_GAS_PER_NODE).mul(count).add(100000).toBigInt(),
      });
      const receipt = await waitForTransactionConfirmation(hash);
      const iface = new ethers.utils.Interface(luckBlocksNodes.abi);
      const mine = receipt.logs
        .filter((log) => log.address.toLowerCase() === nftNodes.toLowerCase())
        .map((log) => {
          try {
            return iface.parseLog(log);
          } catch (err) {
            return null;
          }
        })
        .filter((event) => event && event.name === 'MintRevealed' && event.args.owner.toLowerCase() === address.toLowerCase())
        .map((event) => event.args.tokenId.toNumber());
      if (mine.length) {
        lbDialog.fire({
          title: t('tx.success'),
          text: mine.map((id) => t(id <= 10 ? 'nodes.msgRevealedGolden' : 'nodes.msgRevealed', { id })).join(' '),
          icon: 'success',
        });
      } else {
        // the mint block is not sealed yet, or an expired mint was anchored on a new block
        lbDialog.fire({ title: t('nodes.info'), text: t('nodes.revealWaiting'), icon: 'info', showConfirmButton: false, timer: 3000 });
      }
    } catch (err) {
      lbDialog.fire({ title: t('tx.error'), text: err?.shortMessage || err?.message, icon: 'error' });
    } finally {
      setRevealing(false);
      getMintData();
    }
  }

  // Dashboard Page
  // Helper function to retrieve node information asynchronously
  async function getNodeInfo(i) {
    const checkNode = await contractCFGbckp.nodes(i);
    const nodeId = i;
    const nodeProfit = checkNode.totalProfit;

    // For each contract
    const getStatus = await contractCFG.getNodeStatus(i, luckBlocksAddress);

    return { nodeId, nodeProfit, getStatus };
  }

  const getNodeInfoWithDelay = (i) => {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const nodeInfo = await getNodeInfo(i);
        resolve(nodeInfo);
      }, i * 200); // Multiply the index by 20 milliseconds (0.20 seconds)
    });
  };

  async function getMyNFTs() {
    if (isConnected) {
      // Get Staked NFTs

      // new
      const stakedNfts = await contractCFG.getStakedNodesFromUser(address);
      const convertedStakedNfts = stakedNfts.map((bytes32Value) =>
        ethers.utils.hexlify(bytes32Value)
      );

      // Create an array to hold all the promises
      const promises = [];

      for (const staked of convertedStakedNfts) {
        const stakedId = ethers.BigNumber.from(staked).toNumber();

        promises.push(getNodeInfoWithDelay(stakedId));
      }

      // Use Promise.all to await all promises
      const results = await Promise.all(promises);

      // Process the results
      for (const result of results) {
        const { nodeId, nodeProfit } = result;

        let getStatus;

        if (nodeId < 11) {
          getStatus = await contractCFG.getNodeStatus(nodeId, weeklyContract)
        } else {
          getStatus = await contractCFG.getNodeStatus(nodeId, dailyContract);
        }
        const status = getStatus !== 'notInActive';

        //  console.log("NODE ", nodeId, " STATUS: ", status);

        nftsStakedArray.push({
          id: nodeId,
          totalProfit: parseFloat(
            ethers.utils.formatUnits(nodeProfit, 6)
          ).toFixed(2),
          status: status,
        });
      }

      setStakedNFTs(nftsStakedArray);
      //
      // get wallet NFTs
      const userNfts = await contract.getTokensFromAddress(address);

      const convertedUserNfts = userNfts.map((bytes32Value) =>
        ethers.utils.hexlify(bytes32Value)
      );

      for (const nft of convertedUserNfts) {
        const nftId = ethers.BigNumber.from(nft).toNumber();

        nftsArray.push({
          id: nftId,
        });
      }

      setNFTs(nftsArray);

      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  async function getQueues() {

    // get queues of nodes

    /*  changed to get per contract */
    const [activenodes, activenodesG, waitingnodes, waitingnodesG] =
      await Promise.all([
        contractCFG
          .getActiveNodes(dailyContract)
          .then((values) => values.map((value) => '#' + value)),
        contractCFG
          .getActiveNodes(weeklyContract)
          .then((values) => values.map((value) => '#' + value)),
        contractCFG
          .getWaitingNodes(dailyContract)
          .then((values) => values.map((value) => '#' + value)),
        contractCFG
          .getWaitingNodes(weeklyContract)
          .then((values) => values.map((value) => '#' + value)),
      ]);

    setAQ(activenodes);
    setWQ(waitingnodes);
    setAQG(activenodesG);
    setWQG(waitingnodesG);

    //user active status
    if (isConnected) {

      // changed per contract - (user,contract)

      const userStatus = await contractCFG.getUserActivation(address, dailyContract);
      const userStatusG = await contractCFG.getUserActivation(address, weeklyContract);

      setStatusC(userStatus);
      setStatusG(userStatusG);

    }
    //

    // get next spins
    const lotteryInfos = await multicontract.getLotteryInfos();
    const lotteryInfosW = await multicontract.getLotteryInfosW();

    const getNextSpinBTC = lotteryInfos[0][2] * 1000 + 86400000;
    const getNextSpinWeeklyBTC = lotteryInfosW[0][2] * 1000 + 604800000;
    const getNextSpinETH = lotteryInfos[1][2] * 1000 + 86400000;
    const getNextSpinWeeklyETH = lotteryInfosW[1][2] * 1000 + 604800000;
    const getNextSpinMATIC = lotteryInfos[2][2] * 1000 + 86400000;
    const getNextSpinWeeklyMATIC = lotteryInfosW[2][2] * 1000 + 604800000;
    const getNextSpinCRANNI = lotteryInfos[3][2] * 1000 + 86400000;
    const getNextSpinWeeklyCRANNI = lotteryInfosW[3][2] * 1000 + 604800000;

    const nextSpinsArray = [];
    const nextSpinsArrayW = [];

    for (let i = 0; i < 8; i++) {
      let coinImage;
      let timestamp;

      switch (i) {
        case 0:
          coinImage = 'btc';
          timestamp = parseInt(getNextSpinBTC);
          break;
        case 1:
          coinImage = 'eth';
          timestamp = parseInt(getNextSpinETH);
          break;
        case 2:
          coinImage = 'matic';
          timestamp = parseInt(getNextSpinMATIC);
          break;
        case 3:
          coinImage = 'CRANNI';
          timestamp = parseInt(getNextSpinCRANNI);
          break;
        case 4:
          coinImage = 'btc';
          timestamp = parseInt(getNextSpinWeeklyBTC);
          break;
        case 5:
          coinImage = 'eth';
          timestamp = parseInt(getNextSpinWeeklyETH);
          break;
        case 6:
          coinImage = 'matic';
          timestamp = parseInt(getNextSpinWeeklyMATIC);
          break;
        case 7:
          coinImage = 'CRANNI';
          timestamp = parseInt(getNextSpinWeeklyCRANNI);
          break;
        // Add more cases for additional coins
        default:
          coinImage = null; // Provide a default value if needed
          break;
      }

      if (i < 4) {
        nextSpinsArray.push({
          coin: coinImage,
          time: timestamp,
        });
      } else {
        nextSpinsArrayW.push({
          coin: coinImage,
          time: timestamp,
        });
      }
    }

    setNS(nextSpinsArray);
    setNSW(nextSpinsArrayW);
    setPageChange(false);
  }

  // Logs
  async function loadLogs() {
    const currentBlock = await wsprovider.getBlockNumber();
    const startBlock = currentBlock - 10000;  // testnet: 10000 mainnet: 83200;
    let eventFilter = contractCFG.filters.NftRewarded();
    const items = await contractCFGbckp.queryFilter(
      eventFilter,
      startBlock,
      currentBlock
    );

    /*
    let weventFilter = Whttpcontract.filters.LotteryLog();
    const Witems = await Whttpcontract.queryFilter(weventFilter, startBlock, currentBlock);

    const filteredItems = Witems.filter(function (element) {
      return (
        element.args[2] ===
        "We have a new Weekly Raffle Winner"
      );
    });
    // setTxs(items);
    // console.log("filteredItems", filteredItems);
    if (filteredItems.length > 0) {
      items.push(filteredItems);
    }
    */
    //	console.log(items);
    setTxs(items);
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust the breakpoint as needed
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize); // Update value on window resize

    return () => {
      window.removeEventListener('resize', handleResize); // Clean up event listener
    };
  }, []);

  // pending reveals belong to the connected wallet
  useEffect(() => {
    if (page === 2) getMintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    if (page === 2 && cranniPrice) checkForApproval();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, cranniPrice, address, isConnected]);

  useEffect(() => {
    loadLogs();

    if (page === 2) {
      getMintData();
    }

    if (page === 3) {
      setPageChange(true);
      getMyNFTs();
      getQueues();
    }
  }, [page]);

  useEffect(() => {
    contractCFG.on('UserActivated', handleActivatedEvent);
    contractCFG.on('NftRewarded', handleActivatedEvent);

    return () => {
      // Cleanup: Unsubscribe the event handler when the component unmounts
      contractCFG.off('UserActivated', handleActivatedEvent);
      contractCFG.off('NftRewarded', handleActivatedEvent);
    };
  }, []); // Empty dependency array to run the effect only once

  // Define the event handler functions
  function handleActivatedEvent() {
    setTimeout(() => getQueues(), 1000);
    setTimeout(() => loadLogs(), 3000);
  }

  useEffect(() => {
    if (pageChange === false) {
      resetNfts();
    }
  }, [address, isConnected]);

  useEffect(() => {
    if (pageChange === false) {
      setTimeout(() => getQueues(), 2000);
      setTimeout(() => getMyNFTs(), 4000);
    }
  }, [contractWatched]);

  return (
    <>
      <div className="lb-page relative min-h-screen w-full px-2 py-8 sm:px-4 sm:py-10">
        <div className="relative mx-auto w-full max-w-screen-xl">
          <div className="lb-shell">
            <div className="flex w-full justify-center border-b border-white/5 px-4 py-4">
              <div className="lb-seg">
                {[
                  { page: 1, to: '/nftnodes?section=about', label: t('nav.about') },
                  { page: 2, to: '/nftnodes?section=mintbuy', label: t('nav.mintBuy') },
                  { page: 3, to: '/nftnodes?section=dashboard', label: t('nav.dashboard') },
                  { page: 4, to: '/nftnodes?section=governance', label: t('nav.governance') },
                ].map((tab) => (
                  <Link
                    key={tab.page}
                    to={tab.to}
                    data-active={page === tab.page}
                    data-tone="gold"
                    aria-current={page === tab.page ? 'page' : undefined}
                    className="lb-seg-item"
                  >
                    {tab.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className="w-full px-4 py-8 sm:px-8 sm:py-10">
            {page === 1 ? (
              <>
                <section className="rounded-[32px] border border-white/10 bg-gradient-to-br from-[#0e0b13] via-[#130f19] to-[#1f1729] p-6 text-white shadow-2xl shadow-blue-900/40 sm:p-10">
                  <div className="grid gap-8 lg:grid-cols-[1.2fr,0.8fr]">
                    <div>
                      <p className="text-sm uppercase tracking-[0.4em] text-amber-300">
                        {t('nodes.aboutEyebrow')}
                      </p>
                      <h2 className="mt-4 text-4xl font-extrabold uppercase text-white">
                        {t('nodes.aboutTitle')}
                      </h2>
                      <p className="mt-4 text-lg text-white/80">
                        {t('nodes.aboutBody')}
                      </p>
                      <div className="mt-8 grid gap-4 sm:grid-cols-2">
                        <div className="rounded-2xl border border-white/10 bg-black/40 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/50">
                            {t('nodes.totalSeats')}
                          </p>
                          <p className="mt-2 text-4xl font-bold">50</p>
                          <p className="text-sm text-white/70">
                            {t('nodes.seatsSplit')}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-white/10 bg-black/40 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/50">
                            {t('nodes.coreUtility')}
                          </p>
                          <p className="mt-2 text-4xl font-bold">{t('nodes.autospin')}</p>
                          <p className="text-sm text-white/70">
                            {t('nodes.autospinBody')}
                          </p>
                        </div>
                      </div>
                      <a
                        href="https://docs.luckblocks.com/cranni-societas-nftnodes"
                        target="_blank"
                        rel="noreferrer"
                        className="mt-10 inline-flex items-center rounded-full border border-amber-300 px-6 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-amber-200 transition hover:bg-amber-300/10"
                      >
                        {t('nodes.exploreDocs')}
                      </a>
                    </div>
                    <div className="rounded-[28px] border border-white/10 bg-black/50 p-6 text-white">
                      <h3 className="text-2xl font-semibold">
                        {t('nodes.whyExist')}
                      </h3>
                      <p className="mt-4 text-white/80">
                        {t('nodes.whyExistBody')}
                      </p>
                      <ul className="mt-6 space-y-3 text-sm text-white/80">
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-emerald-400" />
                          {t('nodes.automationBlurb')}
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-cyan-400" />
                          {t('nodes.revenueBlurb')}
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-amber-400" />
                          {t('nodes.governanceScope')}
                        </li>
                      </ul>
                      <div className="mt-8 rounded-2xl border border-white/10 bg-black/40 p-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-white/60">
                          {t('nodes.coreBenefits')}
                        </p>
                        <div className="mt-4 space-y-2 text-sm text-white/80">
                          <p>• {t('nodes.benefitPaid')}</p>
                          <p>• {t('nodes.benefitVotes')}</p>
                          <p>• {t('nodes.benefitUpside')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <NodesFlow />
                <section className="mt-10 grid gap-6 lg:grid-cols-3">
                  {[
                    {
                      title: 'nodes.automationNetwork',
                      body: 'nodes.automationBody',
                    },
                    {
                      title: 'nodes.governance',
                      body: 'nodes.governanceBody',
                    },
                    {
                      title: 'nodes.dashboards',
                      body: 'nodes.dashboardsBody',
                    },
                  ].map((card) => (
                    <div
                      key={t(card.title)}
                      className="rounded-3xl border border-white/10 bg-black/40 p-6 text-white shadow-lg shadow-black/30"
                    >
                      <h4 className="text-xl font-semibold">{t(card.title)}</h4>
                      <p className="mt-3 text-sm text-white/70">{t(card.body)}</p>
                    </div>
                  ))}
                </section>
              </>
            ) : page === 2 ? (
              <>
                <section className="rounded-[32px] border border-white/10 bg-gradient-to-br from-[#110c18] via-[#1f1827] to-[#30243d] p-6 text-white shadow-2xl shadow-blue-900/30 sm:p-10">
                  <div className="text-center">
                    <p className="text-sm uppercase tracking-[0.4em] text-amber-300">
                      Mint &amp; Buy NFTnodes
                    </p>
                    <h2 className="mt-4 text-3xl font-extrabold text-white sm:text-4xl">
                      {t('nodes.joinCircle')}
                    </h2>
                    <p className="mx-auto mt-4 max-w-3xl text-base text-white/70 sm:text-lg">
                      {t('nodes.mintIntro')}
                    </p>
                  </div>

                  <div className="mt-10 grid gap-6 lg:grid-cols-[minmax(0,1.7fr),minmax(0,1fr)]">
                    <div className="rounded-3xl border border-white/10 bg-white/5 p-4 sm:p-6 backdrop-blur">
                      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                          <p className="text-sm uppercase tracking-[0.3em] text-white/60">
                            {t('nodes.mintSchedule')}
                          </p>
                          <h3 className="text-2xl font-semibold">
                            {t('nodes.threePhase')}
                          </h3>
                        </div>
                        <span className="inline-flex items-center rounded-full bg-emerald-500/20 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-emerald-300">
                          {t('nodes.liveCount', { n: remaining })}
                        </span>
                      </div>
                      <div className="mt-6 grid gap-4 sm:grid-cols-2">
                        {phaseTimeline.map((phase) => {
                          const isActive = salePhaseNumber === phase.id;
                          const isComplete = salePhaseNumber > phase.id;
                          const supplyForPhase =
                            phaseSupplyMap[phase.id] ?? 0;
                          const mintedForPhase = isActive
                            ? mintedOnPhase
                            : isComplete
                              ? supplyForPhase
                              : 0;
                          const remainingForPhase = Math.max(
                            supplyForPhase - mintedForPhase,
                            0
                          );
                          const progressForPhase = supplyForPhase
                            ? Math.min(
                              (mintedForPhase / supplyForPhase) * 100,
                              100
                            )
                            : 0;

                          return (
                            <div
                              key={phase.id}
                              className={`w-full rounded-2xl border px-4 py-4 shadow-lg ${
                                isActive
                                  ? 'border-amber-400 bg-black/60 shadow-amber-400/30'
                                  : 'border-white/10 bg-black/40'
                              }`}
                            >
                              <p className="text-xs uppercase tracking-[0.3em] text-white/50">
                                {phase.dates}
                              </p>
                              <h4 className="mt-2 text-lg font-bold">
                                {t(phase.title)}
                              </h4>
                              <p className="text-sm text-white/70">
                                {salePhaseNumber === phase.id ? formattedPrice : phase.price || '—'}
                              </p>
                              <p className="mt-1 text-xs text-white/60">
                                {t(phase.requirement)}
                              </p>
                              <div className="mt-4 flex items-center justify-between text-sm font-semibold">
                                <span
                                  className={
                                    isComplete
                                      ? 'text-emerald-300'
                                      : isActive
                                        ? 'text-amber-300'
                                        : 'text-white/50'
                                  }
                                >
                                  {isComplete
                                    ? t('nodes.phaseDone')
                                    : isActive
                                      ? t('nodes.phaseNow')
                                      : t('nodes.phaseNext')}
                                </span>
                                <span className="text-white/70">
                                  {mintedForPhase}/{supplyForPhase}
                                </span>
                              </div>
                              <div className="mt-2 h-2 w-full rounded-full bg-white/10">
                                <div
                                  style={{
                                    width: `${progressForPhase}%`,
                                  }}
                                  className={`h-full rounded-full ${
                                    isComplete
                                      ? 'bg-emerald-400'
                                      : isActive
                                        ? 'bg-amber-300'
                                        : 'bg-white/30'
                                  }`}
                                />
                              </div>
                              {isActive && (
                                <p className="mt-2 text-xs text-white/60">
                                  {t('nodes.leftInPhase', { n: remainingForPhase })}
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="rounded-3xl border border-white/10 bg-black/70 p-4 sm:p-6 shadow-2xl shadow-black/50 lg:sticky lg:top-6">
                      <p className="text-sm uppercase tracking-[0.4em] text-white/50">
                        {t('nodes.mintPanel')}
                      </p>
                      <h3 className="mt-3 text-2xl font-semibold">
                        {formattedPrice}
                      </h3>
                      <p className="text-sm text-white/70">
                        {t('nodes.priceNote')}
                      </p>

                      <div className="mt-6 space-y-4">
                        <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/60">
                            {t('nodes.step1')}
                          </p>
                          <h4 className="text-lg font-semibold">
                            {t('nodes.approveCranni')}
                          </h4>
                          <p className="mt-2 text-sm text-white/60">
                            {t('nodes.approveBody')}
                          </p>
                          <button
                            onClick={() => !isApproved && approveToSpendCRANNI()}
                            disabled={isApproved}
                            className={`mt-4 w-full rounded-2xl px-4 py-3 text-center text-sm font-semibold uppercase tracking-[0.2em] text-white ${
                              isApproved
                                ? 'bg-emerald-500/30 text-emerald-200'
                                : 'lb-fill-brand hover:opacity-90'
                            }`}
                          >
                            {isApproved ? t('nodes.approved') : t('nodes.approveButton')}
                          </button>
                        </div>

                        <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/60">
                            {t('nodes.step2')}
                          </p>
                          <h4 className="text-lg font-semibold">
                            {t('nodes.mintYours')}
                          </h4>
                          <p className="mt-2 text-sm text-white/60">
                            {isApproved ? t('nodes.mintReady') : t('nodes.mintLocked')}
                          </p>
                          <button
                            onClick={() => isApproved && handleMint()}
                            disabled={!isApproved}
                            className={`mt-4 w-full rounded-2xl px-4 py-3 text-center text-sm font-semibold uppercase tracking-[0.2em] ${
                              isApproved
                                ? 'lb-fill-brand text-white hover:opacity-90'
                                : 'bg-white/10 text-white/40'
                            }`}
                          >
                            {t('nodes.mintButton')}
                          </button>
                        </div>

                        {pendingMints.length ? (
                          <div className="rounded-2xl border border-amber-300/40 bg-amber-400/10 p-4">
                            <p className="text-xs uppercase tracking-[0.3em] text-amber-200/80">
                              {t('nodes.step3')}
                            </p>
                            <h4 className="text-lg font-semibold">
                              {t('nodes.revealTitle')}
                            </h4>
                            <p className="mt-2 text-sm text-white/65">
                              {t('nodes.revealBody', { n: pendingMints.length })}
                            </p>
                            <button
                              onClick={handleReveal}
                              disabled={revealing}
                              className="lb-btn lb-btn-primary mt-4 w-full"
                            >
                              {revealing ? t('nodes.revealing') : t('nodes.revealButton')}
                            </button>
                          </div>
                        ) : null}
                      </div>

                      <div className="mt-6 grid grid-cols-2 gap-3 text-sm">
                        <div className="rounded-2xl border border-white/10 bg-black/30 p-4 text-center">
                          <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                            {t('nodes.currentPhase')}
                          </p>
                          <p className="mt-1 text-2xl font-bold">
                            {salePhaseNumber + 1}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-white/10 bg-black/30 p-4 text-center">
                          <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                            {t('nodes.nftsLeft')}
                          </p>
                          <p className="mt-1 text-2xl font-bold">
                            {remainingOnPhase}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-white/10 bg-black/30 p-4 text-center">
                          <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                            {t('nodes.supply')}
                          </p>
                          <p className="mt-1 text-2xl font-bold">
                            {totalPhaseSupply}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-white/10 bg-black/30 p-4 text-center">
                          <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                            {t('nodes.progress')}
                          </p>
                          <p className="mt-1 text-2xl font-bold">
                            {mintedProgress.toFixed(0)}%
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-10 grid gap-6 lg:grid-cols-2">
                    <div className="rounded-[28px] border border-white/10 bg-black/50 p-6 backdrop-blur">
                      <h3 className="text-2xl font-semibold">
                        {t('nodes.rarityTitle')}
                      </h3>
                      <p className="mt-3 text-white/70">
                        {t('nodes.rarityBody')}
                      </p>
                      <div className="mt-6 grid gap-4 sm:grid-cols-2">
                        <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-amber-500/30 to-rose-500/40 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/70">
                            {t('nodes.goldenSupply')}
                          </p>
                          <p className="mt-2 text-3xl font-bold">10</p>
                          <p className="text-sm text-white/70">
                            {t('nodes.goldenBlurb')}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-slate-500/20 to-blue-500/30 p-4">
                          <p className="text-xs uppercase tracking-[0.3em] text-white/70">
                            {t('nodes.commonSupply')}
                          </p>
                          <p className="mt-2 text-3xl font-bold">40</p>
                          <p className="text-sm text-white/70">
                            {t('nodes.dashboardsBlurb')}
                          </p>
                        </div>
                      </div>
                      <ul className="mt-6 space-y-3 text-sm text-white/80">
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-emerald-400" />
                          {t('nodes.executorDashboard')}
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-sky-400" />
                          {t('nodes.rewardsBlurb')}
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-amber-400" />
                          {t('nodes.governanceBlurb')}
                        </li>
                      </ul>
                    </div>
                    <div className="rounded-[28px] border border-white/10 bg-black/40 p-4 text-center">
                      <div className="overflow-hidden rounded-[24px] border border-white/10 shadow-2xl">
                        <img
                          src={crannigif}
                          alt={t('nodes.showcase')}
                          className="h-full w-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <p className="mt-4 text-sm uppercase tracking-[0.3em] text-white/60">
                        {t('nodes.immutableSupply')}
                      </p>
                    </div>
                  </div>
                </section>

                <div className="mt-10 rounded-[32px] border border-white/10 bg-black/60 p-6 text-white shadow-inner shadow-black/40 sm:p-10">
                  <div className="text-center">
                    <p className="text-sm uppercase tracking-[0.4em] text-white/60">
                      {t('nodes.secondaryMarket')}
                    </p>
                    <h3 className="mt-2 text-3xl font-semibold">
                      {t('nodes.buyFromCollectors')}
                    </h3>
                    <p className="mt-3 text-white/70">
                      If the primary sale is sold out or you want a
                      specific trait, browse the verified marketplaces
                      below.
                    </p>
                  </div>
                  <div className="mt-8 grid gap-4 sm:grid-cols-2">
                    {marketplaceLinks.map((marketplace) => (
                      <a
                        key={marketplace.name}
                        href={marketplace.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`group flex items-center gap-4 rounded-2xl border border-white/10 bg-gradient-to-r ${marketplace.accent} px-5 py-4 text-left shadow-lg transition hover:scale-[1.01] hover:border-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40`}
                      >
                        <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/30 bg-white/90 shadow-sm">
                          <img
                            src={marketplace.logo}
                            alt={marketplace.name}
                            className="h-8 w-8 object-contain"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <p className="text-xs uppercase tracking-[0.3em] text-white/70">
                            {t('nodes.marketplace')}
                          </p>
                          <p className="text-xl font-semibold text-white">
                            {marketplace.name}
                          </p>
                          <span className="text-sm text-white/80 group-hover:text-white">
                            {t('nodes.openListing')}
                          </span>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </>
            ) : page === 4 ? (
              <Governance />
            ) : (
              <>
                <div className="mb-6 sm:mb-10">
                  <NodeTasks />
                </div>
                {isConnected ? (
                  <div className="space-y-6 sm:space-y-10">
                    <section id="my-nodes" className="scroll-mt-24 rounded-[32px] border border-white/10 bg-black/50 p-4 text-white shadow-2xl shadow-black/40 sm:p-6">
                      <h2 className="text-center text-3xl font-display">
                        {t('nodes.overview')}
                      </h2>
                      <p className="mt-2 text-center text-sm text-white/70">
                        {t('nodes.overviewBlurb')}
                      </p>
                      <div className="mt-8 grid items-start gap-6 xl:grid-cols-[2fr,1fr]">
                        <div className="min-w-0 overflow-hidden rounded-3xl border border-white/10 bg-black/40 p-4">
                          <h3 className="text-center text-2xl font-semibold">
                            {t('nodes.staked')}
                          </h3>
                          {loading ? (
                            <div className="flex justify-center py-10">
                              <Spinner size="lg" />
                            </div>
                          ) : nftsStaked.length > 0 ? (
                            <Suspense>
                              <CarouselInStaked
                                nfts={nftsStaked}
                                resetNfts={resetNfts}
                              />
                            </Suspense>
                          ) : (
                            <p className="py-10 text-center text-white/70">
                              {t('nodes.noneStaked')}
                            </p>
                          )}
                        </div>
                        <div className="min-w-0 overflow-hidden rounded-3xl border border-white/10 bg-black/40 p-4">
                          <h3 className="text-center text-2xl font-semibold">
                            {t('nodes.inWallet')}
                          </h3>
                          {loading ? (
                            <div className="flex justify-center py-10">
                              <Spinner size="lg" />
                            </div>
                          ) : nftsInWallet.length > 0 ? (
                            <Suspense>
                              <CarouselInWallet
                                nfts={nftsInWallet}
                                resetNfts={resetNfts}
                              />
                            </Suspense>
                          ) : (
                            <p className="py-10 text-center text-white/70">
                              {t('nodes.noneInWallet')}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mt-6 text-center text-sm text-white/70">
                        {t('nodes.automationLink')}{' '}
                        <a
                          className="text-amber-400 underline-offset-4 hover:underline"
                          href="https://docs.luckblocks.com/auto-spin-draw/how-to-configure-automation"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t('nodes.clickHere')}
                        </a>
                      </div>
                    </section>

                  </div>
                ) : null}
              </>
            )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <Suspense>
          <NFTLogs transactions={txs} />
        </Suspense>
      </div>
    </>
  );
};

export default NFTnodes;
